module.exports = __webpack_public_path__ + "img/hand-index-fill.f0d98be8.svg";